// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2RhpS","options":"AnswerScale_options__2qJRE","selected":"AnswerScale_selected__xJDuv"};